<div class="wrapper">
  <mat-icon>{{ data?.iconKey }}</mat-icon>
  <span>{{ data?.messageKey | translate }}</span>
</div>
